import React, { useState } from 'react';
import styles from './AboutUs.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faInstagram,
  faTiktok
} from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { getComponentTranslator } from '../../util/i18n';

const translate = getComponentTranslator('aboutUs');

const AboutUs = () => {
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <div className={styles.aboutUsContainer}>
      <div className={styles.contentSection}>
        <div className={styles.leftSection}>
          <img
            src="https://png.pngtree.com/png-vector/20240318/ourmid/pngtree-sticker-of-a-cartoon-genius-png-image_12004528.png"
            alt="Monster mascot"
            className={styles.mascot}
          />
        </div>

        <div className={styles.rightSection}>
          <h1>Om Grundaren</h1>
          <div className={styles.textContent}>
            <p>
              Hej! Jag heter <strong>Baraa</strong> och är en tidigare elev på NTI Gymnasiet Helsingborg.
            </p>

            <p>
              Jag byggde denna webbplats som mitt <strong>Gymnasiearbete</strong>. Idén föddes ur en vilja att skapa något spännande och interaktivt för att lösa problemet med att samla och visa upp skolans minnen och prestationer på ett engagerande sätt.
            </p>

            <p>
              Projektet har varit en otrolig resa där jag fått utveckla mina kunskaper inom modern webbutveckling och design. Min vision var att leverera en produkt som inte bara fungerar felfritt, utan också känns professionell och tilltalande.
            </p>

            <p style={{ marginTop: '10px', fontStyle: 'italic', fontSize: '0.95rem' }}>
              Nedan hittar du länkar för att följa NTI Gymnasiet och se allt spännande som händer på skolan där allt började!
            </p>
          </div>

          <div className={styles.socialIcons}>
            <a href="https://www.tiktok.com/@nti_helsingborg" target="_blank" rel="noopener noreferrer" title="NTI TikTok">
              <FontAwesomeIcon icon={faTiktok} />
            </a>
            <a href="https://www.facebook.com/ntihelsingborg/?locale=sv_SE" target="_blank" rel="noopener noreferrer" title="NTI Facebook">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://ntigymnasiet.se/helsingborg/" target="_blank" rel="noopener noreferrer" title="NTI Hemsida">
              <FontAwesomeIcon icon={faGlobe} />
            </a>
            <a href="https://www.instagram.com/ntihelsingborg/?hl=en" target="_blank" rel="noopener noreferrer" title="NTI Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>
      </div>

      {/* Service Modal - Hidden/Removed buttons as per new focus, or kept if generic info needed? 
          User removed them visually in description but kept code? 
          User said "skriva om länker som finns för att följa skolan", removing generic "Service/Contact" buttons might be cleaner if they are generic lorem ipsum.
          But I'll leave the modals logic if user wants to keep them, but I will REMOVE the buttons from UI as they distract from the personal story.
      */}

    </div>
  );
};

export default AboutUs;
